<template>
  <div class="card">
    <Tabs type="card" @on-click="tabsChange">
      <TabPane label="个人中心">
        <!-- <Form class="infoForm" :label-width="80">
          <FormItem label="会员账号：">
            <span>{{userData.userName}}</span>
          </FormItem>
          <FormItem label="真实姓名：">
            <span>{{userData.name}}</span>
          </FormItem>
          <FormItem label="手机：">
            <span>{{userData.phoneNumber}}</span>
          </FormItem>
          <FormItem label="邮箱：">
            <span>{{userData.emailAddress}}</span>
          </FormItem>
          <FormItem label="公司名称：">
            <span>{{companyData.companyName}}</span>
          </FormItem>
          <FormItem label="公司电话：">
            <span>{{companyData.companyTel}}</span>
          </FormItem>
          <FormItem label="行业分类：">
            <span>{{companyData.companyType}}</span>
          </FormItem>
          <FormItem label="公司地址：">
            <span>{{companyData.companyAddress}}</span>
          </FormItem>
          <FormItem label="公司邮箱：">
            <span>{{companyData.companyMail}}</span>
          </FormItem>
          <FormItem label="法人：">
            <span>{{companyData.legalPerson}}</span>
          </FormItem>
          <FormItem label="法人电话：">
            <span>{{companyData.legalPersonTel}}</span>
          </FormItem>
        </Form> -->
        <div class="infoForm">
          <div class="header">
            <h2>{{userData.name}}</h2>
            <h3>账号ID：{{userData.userName}}</h3>
            <h3>上次登录时间：{{userData.lastLoginTime}}</h3>
          </div>
          <div class="infobody">
            <h3>手机：{{userData.phoneNumber}}</h3>
            <h3>邮箱：{{userData.emailAddress}}</h3>
            <!-- <h3>所属公司/部门：{{companyData.companyName}}</h3> -->
            <h3 style="display:flex">
              <div>所属公司/部门：</div>
              <div style="flex: 1">
                <span v-for="(list,index) in session.listOrg" :key="index">{{list.displayName}}</span>
              </div>
            </h3>
            <h3>地区：{{session.user.selectDistrict}}</h3>
            <h3 style="display:flex">
              <div>角色：</div>
              <div style="flex: 1">
                <span v-for="(role,index) in roles" :key="index">{{role}}</span>
              </div>
            </h3>
            <!-- <h3>公司电话：{{companyData.companyTel}}</h3>
            <h3>行业分类：{{companyData.companyType}}</h3>
            <h3>公司地址：{{companyData.companyAddress}}</h3>
            <h3>公司邮箱：{{companyData.companyMail}}</h3>
            <h3>法人：{{companyData.legalPerson}}</h3>
            <h3>法人电话：{{companyData.legalPersonTel}}</h3> -->
          </div>
        </div>
      </TabPane>
      <!-- <TabPane label="修改个人信息">
        <Form class="reviseInfo" ref="userForm" :model="userForm" :label-width="120" :rules="ruleValidate">
          <FormItem label="会员账号" prop="name">
            <Input v-model="userForm.name" placeholder="会员账号"></Input>
          </FormItem>
          <FormItem label="真实姓名" prop="realName">
            <Input v-model="userForm.realName" placeholder="真实姓名"></Input>
          </FormItem>
          <FormItem label="电子邮箱" prop="Email">
            <Input v-model="userForm.Email" placeholder="电子邮箱"></Input>
          </FormItem>
        </Form>
        <div style="margin-bottom: 16px;text-align:center">
          <Button type="primary" @click="reviseUserInfo">提交修改</Button>
        </div>
      </TabPane> -->
      <!-- <TabPane label="修改公司信息">
        <Form class="reviseInfo" ref="companyForm" :model="userForm" :label-width="120" :rules="ruleValidate">
          <div style="position:relative;left:-90px;width:590px;">
            <FormItem required label="统一社会信用代码" prop="creditCode" :label-width="210">
              <Input v-model="userForm.creditCode" placeholder="请确统一社会信用代码准确有效"></Input>
            </FormItem>
          </div>
          <FormItem label="公司名称" prop="company">
            <Input disabled="disabled" v-model="userForm.company" placeholder="请输入统一社会信用代码（自动识别）" style="color: #000"></Input>
          </FormItem>
          <FormItem label="行业分类" prop="industryCategory">
            <Select v-model="userForm.industryCategory">
              <Option value="企业单位">企业单位</Option>
              <Option value="事业或社会团体">事业或社会团体</Option>
              <Option value="个体经营">个体经营</Option>
              <Option value="其他">其他</Option>
            </Select>
          </FormItem>
          <FormItem label="公司电话" prop="companyPhone">
            <Input v-model="userForm.companyPhone" placeholder="公司电话"></Input>
          </FormItem>
          <FormItem label="公司地址" prop="companyAddress">
            <Input v-model="userForm.companyAddress" placeholder="公司地址"></Input>
          </FormItem>
          <FormItem label="公司邮箱" prop="companyMail">
            <Input v-model="userForm.companyMail" placeholder="公司邮箱"></Input>
          </FormItem>
          <div>
            <FormItem required label="邮箱验证码" prop="validEmail" style="width: 320px;display:inline-block">
              <Input v-model="userForm.validEmail" placeholder="邮箱验证码" style="width: 200px"></Input>
            </FormItem>
            <Button type="primary" size="small" style="margin:5px 20px;" @click="getMailCode" :disabled="mailDisabled">{{mailValidText}}</Button>
          </div>
          <FormItem label="法人" prop="legalPerson">
            <Input v-model="userForm.legalPerson" placeholder="法人"></Input>
          </FormItem>
          <FormItem label="法人电话" prop="legalPersonTel">
            <Input v-model="userForm.legalPersonTel" placeholder="法人电话"></Input>
          </FormItem>
        </Form>
        <div style="margin-bottom: 16px;text-align:center">
          <Button type="primary" @click="reviseCompanyInfo">提交修改</Button>
        </div>
      </TabPane> -->
      <TabPane label="个人考勤记录">
        <iframe style="width:100%;height:100%" :src="iframeUrl"></iframe>
      </TabPane>
      <TabPane label="企业邮箱密码">
        <iframe style="width:100%;height:100%" :src="iframeUrl"></iframe>
      </TabPane>
      <TabPane label="修改共享服务器密码" style="padding: 10px">
        <!-- <iframe style="width:100%;height:100%" :src="iframeUrl"></iframe> -->
        <!-- <div style="margin: 10px">
          <span style="display:inline-block;width:80px">用户名：</span>{{ $store.state.session.user.name }}
        </div>
        <div style="margin: 10px">
          <span style="display:inline-block;width:80px">旧密码：</span>
          <Input v-model="oldPassword" type="password" style="width: 200px"></Input>
        </div>
        <div style="margin: 10px">
          <span style="display:inline-block;width:80px">新密码：</span>
          <Input v-model="newPassword" type="password" style="width: 200px" :maxlength="20"></Input>
          <span>（8-20位，必须同时包含字母和数字）</span>
        </div>
        <div style="margin: 10px">
          <span style="display:inline-block;width:80px">确认新密码：</span>
          <Input v-model="confirmPsw" type="password" style="width: 200px"></Input>
        </div>
        <Button type="primary" style="margin-left: 90px;width: 200px" @click="submit">保存修改</Button>
        <div style="color: red;margin-top: 20px">
          <p>*1.本密码仅适用于【财务网报系统】与【共享服务器】，初始密码为cl000000，</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;请修改密码后再进行相关帐号的登录，否则可能导致帐号封停。</p>
        </div> -->
        <Form ref="pswForm" :model="pswForm" label-position="right" :label-width="100" :rules="rules">
          <Row><input-select span="6" label="用户名：" type="text" :content="$store.state.session.user.name"></input-select></Row>
          <Row style="margin-top: 15px;width: 314px">
            <input-select label="旧密码：" dataType="password" v-model="pswForm.oldPassword" prop="oldPassword"></input-select>
          </Row>
          <Row style="margin-top: 15px">
            <input-select label="新密码：" span="24" style="width: 314px" dataType="password" v-model="pswForm.newPassword" prop="newPassword"></input-select>
            <span style="line-height: 32px">（8-20位，必须同时包含字母和数字）</span>
          </Row>
          <Row style="margin-top: 15px;width: 314px">
            <input-select label="确认新密码：" dataType="password" v-model="pswForm.confirmPsw" prop="confirmPsw"></input-select>
          </Row>
          <Row style="margin-top: 15px">
            <Button type="primary" style="margin-left: 100px;width: 214px" @click="submit">保存修改</Button>
          </Row>
          <Row style="color: red;padding: 15px">
            <p>*1.本密码仅适用于【财务网报系统】与【共享服务器】，初始密码为cl000000，</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;请修改密码后再进行相关帐号的登录，否则可能导致帐号封停。</p>
          </Row>
        </Form>
      </TabPane>
    </Tabs>
    <Spin fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import Util from '../../lib/util'
import ajax from '../../lib/ajax'
import userAjax from '../../lib/userAjax'
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import util from "@/lib/util"
import { setTimeout } from 'timers'
import inputSelect from '@/components/inputSelect'

const userId = Util.abp.session.userId

export default {
  name: 'userProfile',
  components: {
    inputSelect
  },
  data() {
    const validateCreditCode = async (rule, value, callback) => {
      if (value === '') {
        this.userForm.company = ''
        callback(new Error('请输入统一社会信用代码'))
      } else {
        const url = `https://www.creditchina.gov.cn/api/public_search/getCreditCodeFacades?keyword=${value}&filterManageDept=0&filterOrgan=0&filterDivisionCode=0&page=1&pageSize=10`
        // 这里只能使用不附加任何请求头的请求库
        let rep = await axios.get(url)

        if (rep.data.message === '成功') {
          if (this.userForm.creditCode === rep.data.results[0].creditCode) {
            this.userForm.company = rep.data.results[0].entname
          }
          callback()
        } else {
          this.userForm.company = ''
          callback(new Error('请确认您输入的统一社会信用代码'))
        }
      }
    }
    const validateValidMail = (rule, value, callback) => {
      let mailValidCode = '000000' + this.mailValidCode * 1717
      mailValidCode = mailValidCode.slice(-6)
      if (value === '') {
        callback(new Error('请输入邮箱验证码'))
      } else if (this.userForm.validEmail !== mailValidCode || this.userForm.companyMail !== this.getValidCodeMail) {
        callback(new Error('邮箱验证码不正确'))
      } else {
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value !== this.pswForm.newPassword) {
        callback(new Error('两次输入的密码不匹配！'));
      } else {
        callback();
      }
    }
    return {
      userData: {},
      companyData: {},
      userForm: {
        name: '',
        company: '',
        creditCode: '',
        industryCategory: '',
        companyPhone: '',
        realName: '',
        Email: '',
        validEmail: '',
        telphone: '',
        companyAddress: '',
        companyMail: '',
        legalPerson: '',
        legalPersonTel: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入会员名' }
        ],
        company: [
          { required: true, message: '公司名称不能为空' }
        ],
        creditCode: [
          { validator: validateCreditCode, trigger: 'blur' }
        ],
        industryCategory: [
          { required: true, message: '请输入行业分类' }
        ],
        companyPhone: [
          { required: true, message: '请输入公司电话' },
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '请检查您输入的号码', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入真实姓名' }
        ],
        Email: [
          { required: true, message: '请输入电子邮箱' },
          { type: 'email', message: '请输入正确的邮箱' }
        ],
        telphone: [
          { required: true, message: '请输入手机号码' },
          { type: 'string', pattern: /1[0-9]{10}$/, message: '请检查您输入的号码', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: '请输入公司地址' },
        ],
        companyMail: [
          { required: true, message: '请输入公司邮箱' },
          { type: 'email', message: '请输入正确的邮箱' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名' }
        ],
        legalPersonTel: [
          { required: true, message: '请输入法人电话' },
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '请检查您输入的号码', trigger: 'blur' }
        ],
        validEmail: [
          { validator: validateValidMail, trigger: 'blur' }
        ]
      },
      mailValidCode: '',
      getValidCodeMail: '',
      mailDisabled: false,
      mailInterval: '',
      mailCount: 60,
      mailValidText: '获取邮箱验证码',
      spinShow: false,
      iframeUrl: '',
      pswForm: {
        oldPassword: '',
        newPassword: '',
        confirmPsw: ''
      },
      rules: {
        oldPassword: { required: true, message: '旧密码不能为空', trigger: 'blur' },
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          { pattern: /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,20}$/, message: '新密码为8-20位字母与数字的组合', trigger: 'blur' },
        ],
        confirmPsw: [{ validator: validatePassCheck, trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    // 获取信息
    async getInfo() {
      await this.$store.dispatch({
        type: 'session/init'
      })
      // 个人信息
      const userInfo = this.$store.state.session.user
      this.userData = userInfo
      this.userData.lastLoginTime = this.$store.state.session.application.releaseDate.slice(0,10)
      this.userForm.name = userInfo.userName
      this.userForm.realName = userInfo.name
      this.userForm.Email = userInfo.emailAddress
      this.userForm.telphone = userInfo.phoneNumber
      // 公司信息
      if (this.$store.state.session.company) {
        const companyInfo = this.$store.state.session.company
        this.companyData = companyInfo
        this.userForm.company = companyInfo.companyName
        this.userForm.creditCode = companyInfo.companyNo
        this.userForm.industryCategory = companyInfo.companyType
        this.userForm.companyPhone = companyInfo.companyTel
        this.userForm.companyAddress = companyInfo.companyAddress
        this.userForm.companyMail = companyInfo.companyMail
        this.userForm.legalPerson = companyInfo.legalPerson
        this.userForm.legalPersonTel = companyInfo.legalPersonTel
      }
    },
    reviseUserInfo() {
      this.$refs.userForm.validate(async valid => {
        if (valid) {
          const data = {
            "userName": this.userForm.name,
            "name": this.userForm.realName,
            "phoneNumber": this.userData.phoneNumber,
            "emailAddress": this.userForm.Email,
            "isActive": this.userData.isActive,
            "lastLoginTime": this.userData.lastLoginTime,
            "creationTime": this.userData.creationTime,
            "roleNames": this.userData.roleNames,
            "id": this.userData.id
          }
          this.spinShow = true
          try {
            let rep = await ajax.put('/api/services/app/User/Update', data)
            this.spinShow = false
            if (rep.data.success) {
              this.$Message.success('修改成功')
              this.getInfo()
            } else {
              this.$Message.success('修改失败')
            }
          } catch (err) {
            this.spinShow = false
            this.$Message.success('修改失败')
          }
        }
      })
    },
    reviseCompanyInfo() {
      this.$refs.companyForm.validate(async valid => {
        if (valid) {
          const data = {
            "company": {
              "id": this.companyData.id,
              "companyNo": this.userForm.creditCode,
              "companyName": this.userForm.company,
              "companyType": this.userForm.industryCategory,
              "companyTel": this.userForm.companyPhone,
              "companyAddress": this.userForm.companyAddress,
              "companyMail": this.userForm.companyMail,
              "legalPerson": this.userForm.legalPerson,
              "legalPersonTel": this.userForm.legalPersonTel
            }
          }
          this.spinShow = true
          try {
            let rep = await ajax.post('/api/services/app/AbpCompany/CreateOrUpdate', data)
            this.spinShow = false
            if (rep.data.success) {
              this.$Message.success('修改成功')
              this.getInfo()
            } else {
              this.$Message.success('修改失败')
            }
          } catch (err) {
            this.spinShow = false
            this.$Message.success('修改失败')
          }
        }
      })
    },
    getMailCode() {
      this.$refs.companyForm.validateField('companyMail', async valid => {
        // valid返回错误信息
        if (!valid) {
          // 倒计时
          this.validCount('mail')
          //发送请求
          let url = 'https://wx.chinapsp.cn/api3/mailValidate'
          this.mailValidCode = this.getValidCode()
          this.getValidCodeMail = this.userForm.companyMail
          let params = {
            validateCode: this.mailValidCode,
            toMail: this.userForm.companyMail
          }
          let rep = await axios({
            methods: 'get',
            url: url,
            params: params
          })
          if (rep.data.message === '请勿重复发送') {
            this.$Message.error('发送过于频繁，请一分钟后再尝试')
          }
        }
      })
    },
    getValidCode() {
      const num = '0123456789'
      let resultNum = ''
      let time = 6
      while (time--) {
        resultNum += num[Math.floor(Math.random() * 10)]
      }
      return resultNum
    },
    validCount(type) {
      if (type === 'phone') {
        this.phoneDisabled = true
        this.phoneInterval = setInterval(() => {
          this.phoneCount--
          if (this.phoneCount > 0) {
            this.phoneValidText = `重新获取(${this.phoneCount})`
          } else {
            clearInterval(this.phoneInterval)
            this.phoneValidText = `获取手机验证码`
            this.phoneDisabled = false
            this.phoneCount = 60
          }
        }, 1000)
      }
      if (type === 'mail') {
        this.mailDisabled = true
        this.mailInterval = setInterval(() => {
          this.mailCount--
          if (this.mailCount > 0) {
            this.mailValidText = `重新获取(${this.mailCount})`
          } else {
            clearInterval(this.mailInterval)
            this.mailValidText = `获取邮箱验证码`
            this.mailDisabled = false
            this.mailCount = 60
          }
        }, 1000)
      }
    },
    tabsChange(tab) {
      switch (tab) {
        // 个人信息
        case 0:
        break
        // 个人考勤记录
        case 1:
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/人力模块/attendance.cpt&op=write&&name=${this.userForm.realName}`
        break
        // 企业邮箱密码
        case 2:
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/修改个人密码/企业邮箱密码.cpt&op=write&name=${this.userForm.realName}`
        break
        // 修改共享服务器密码
        case 3:
          this.iframeUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/修改个人密码/修改OA密码.cpt&op=write&name=${this.userForm.realName}`
        break
      }
    },
    submit() {
      this.$refs['pswForm'].validate((valid) => {
        if (valid) {
          this.$Spin.show()
          userAjax.post(`/api/services/app/Synchronize/ChangeACPassword`,{
            abpUserId: this.$store.state.session.user.id,
            oldPassword: this.pswForm.oldPassword,
            newPassword: this.pswForm.newPassword,
            repeatPassword: this.pswForm.confirmPsw
          }).then(res => {
            this.$Spin.hide()
            this.$Message.info(res.data.result)
            this.$refs['pswForm'].resetFields()
          })
        }
      })
    }
  },
  computed: {
    roles () {
      return this.$store.state.session.roleNames
    },
    session () {
      return this.$store.state.session
    }
  }
}
</script>

<style lang="less" scoped>
form {
  max-height: 800px;
}
// .infoForm {
//   width: 400px;
//   margin: 20px auto;
//   .ivu-form-item {
//     margin-bottom: 5px;
//   }
// }
.card {
  height: 100%
}
.infoForm{
  width:600px;
  margin:50px auto;
  padding: 0 16px;
}
.header h3{
  display: inline-block;
  margin:10px 80px 40px 0px;
  font-weight: normal;
}
.infobody h3{
  padding:10px 0px;
  border-bottom: 1px solid #ccc;
  span + span::before {
    content: '   |   '
  }
}
.reviseInfo {
  width: 500px;
  margin: 20px auto 10px;
}
// 修改Tab样式
/deep/.ivu-tabs-bar {
  margin-bottom: 0;
}
/deep/.ivu-tabs-content {
  height: 100%;
}
.card > .ivu-tabs.ivu-tabs-card {
  height: 100%;
}
.card > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #fff;
}
.card > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  border-top: 1px solid #3399ff;
}
.card > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #3399ff;
  position: absolute;
  top: 0;
  left: 0;
}
.card > .ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane {
  // margin-top: -16px;
  background: #fff;
  border: 1px solid #dcdee2;
  border-top: 0;
}
/deep/ .ivu-tabs-bar {
  margin-bottom: 0;
}
</style>
